import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker as MUIDatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

function DatePicker({
  onSelect,
  selected,
  name,
  disabled = false,
  minDate,
}: any) {
  const defaultMinDate = dayjs("1900=01-01").startOf("day");
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePicker"]} sx={{ padding: "0px" }}>
        <MUIDatePicker
          sx={{
            outline: "#dddfe2",
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#dddfe2",
              },
              "&:hover fieldset": {
                borderColor: "#dddfe2",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#dddfe2",
              },
            },
            
          }}
          label={""}
          disabled={disabled}
          name={name}
          minDate={minDate ? dayjs(minDate) : defaultMinDate}
          value={selected ? dayjs(selected) : null}
          onChange={(newValue) => onSelect(newValue)}
          format="YYYY-MM-DD"
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}

export { DatePicker };
